import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {RolEntity} from '../entities/usuario.entity';
import {ALLPERMISOS, ALLROLES, EDITROL, NEWROL, ROL} from '../queries/roles.query';

@Injectable()
export class RolServices {

  constructor(private apollo:Apollo){}

  getRol(id){
    return this.apollo.query<any>({
      query:ROL,
      variables:{
        id:id
      }
    })
  }

  getRoles(){
    return this.apollo.query<any>({
      query:ALLROLES
    });
  }

  creteRol(rol:RolEntity){
    return this.apollo.mutate<any>({
      mutation:NEWROL,
      variables:{
        nombre:rol.nombre,
        permisos:rol.permisos
      }
    })
  }

  updateRol(rol:RolEntity){

    console.log(rol);

    return this.apollo.mutate<any>({
      mutation:EDITROL,
      variables:{
        id:+rol.id,
        nombre:rol.nombre,
        permisos:rol.permisos
      }
    })
  }

  getPermisos(){
    return this.apollo.query<any>({
      query:ALLPERMISOS
    });
  }



}
